import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const ImprintMaxwilkinson = () => {
  const title = "{BRAND.domainLabel} meets with Max Wilkinson MP and Emily Darlington MP to discuss online safety."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                In May 2025, {BRAND.domainLabel} continued its engagement with
                political stakeholders in the UK to discuss the importance of
                online safety.
              </p>

              <p>
                On 12 May, {BRAND.domainLabel} met with Emily Darlington MP to discuss
                online safety. It was a productive meeting that provided an
                opportunity to showcase the platform and highlight the community
                guidelines and safety policies designed to protect all users.
                Emily shared valuable insight into her interests and work,
                particularly her focus on keeping women and girls safe.
              </p>

              <p>
                On 14 May, {BRAND.domainLabel} met with Max Wilkinson MP who is the
                current Liberal Democrat Spokesperson for Culture, Media and
                Sport. Max sponsors the Jools&apos; Law Bill in the UK
                Parliament, in 6 support of the work being done by his
                constituent, Ellen Roome, whose son Jools Sweeney tragically
                took his own life, aged 14.
              </p>

              <p>
                Since the meeting with Max, {BRAND.domainLabel} has been in contact
                with Ellen Roome, seeking her valuable insights to support the
                development of stronger safety features on {BRAND.domainLabel}.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default ImprintMaxwilkinson;
